import { MailConversationDataType } from "../../types";
import EventBus from "../event-bus";
const conversationChangeHook = new EventBus<MailConversationDataType>(
  "conversationChangeHook"
);

export default conversationChangeHook;
